import React, { useEffect } from 'react';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { WhyFailedSection } from './components/WhyFailedSection';
import { ForYouSection } from './components/ForYouSection';
import { NotForYouSection } from './components/NotForYouSection';
import { SolutionSection } from './components/SolutionSection';
import { PricingSection } from './components/PricingSection';
import { Footer } from './components/Footer';
import { initPixel, trackPageView } from './utils/pixel';
export function App() {
  useEffect(() => {
    initPixel();
    trackPageView();
  }, []);
  return <div className="min-h-screen bg-navy-900 text-offwhite font-sans selection:bg-amber-500 selection:text-navy-900" data-id="element-0">
      <main data-id="element-1">
        <HeroSection data-id="element-2" />
        <ProblemSection data-id="element-3" />
        <WhyFailedSection data-id="element-4" />
        <ForYouSection data-id="element-5" />
        <NotForYouSection data-id="element-6" />
        <SolutionSection data-id="element-7" />
        <PricingSection data-id="element-8" />
      </main>
      <Footer data-id="element-9" />
    </div>;
}